window.oxOfferMath = {
 reference(variant) { return Number(variant.compare_at_price) > Number(variant.price) ? Number(variant.compare_at_price) : Number(variant.price); },
 quantity(variant, quantity, hoodie = false, profitRates = null) {
  const qty=Math.max(1,Math.floor(Number(quantity)||1));
  const extra=qty>=3?15:qty>=2?(hoodie?10:5):0;
  const saleTotal=Number(variant.price)*qty;
  const quantitySaving=Math.floor((Number(variant.price)*extra+0.000001)/100)*qty;
  const freeSaving=hoodie&&qty>=5?Number(variant.price):0;
  const rates=profitRates?.variants?.[String(variant.id)]||profitRates;
  const profitRate=rates?(qty>=3?rates.three:qty>=2?rates.two:0):null;
  const total=profitRates?saleTotal-(rates?.mode==='amount'?profitRate:Math.floor(Number(variant.price)*profitRate+0.000001))*qty:saleTotal-Math.max(quantitySaving,freeSaving);
  const reference=this.reference(variant)*qty;
  return {total,reference,saving:reference-total,hasCompare:reference>saleTotal,extraSaving:saleTotal-total};
 },
 percent(reference,total) { return reference>0 ? Number(((reference-total)*100/reference).toFixed(1)) : 0; }
};
